module.exports = __webpack_public_path__ + "img/icon-mail.3d3f3286.svg";